import { Component } from "solid-js";

import fixing from "../assets/fixing.svg";

export const SiteUnderMaintenance: Component = () => {
  return (
    <section class="flex h-full items-center justify-center">
      <div class="max-w-lg space-y-6 p-4">
        <img src={fixing} class="mx-auto" alt="Broken computer" width={250} />
        <h1 class="text-center text-xl">
          The platform is undergoing essential maintenance
        </h1>
        <p class="text-center">
          Apologies for any inconvenience caused and we thank you for your
          patience.
        </p>
      </div>
    </section>
  );
};
